const footerLinks = [
  {
    title: 'サービス',
    links: [
      { label: 'サービス概要', href: '#service' },
      { label: '特徴・強み', href: '#features' },
      { label: '料金プラン', href: '#pricing' },
      { label: '導入実績', href: '#results' },
      { label: 'よくある質問', href: '#faq' },
      { label: 'お問い合わせ', href: '#contact' },
    ],
  },
  {
    title: '対応媒体',
    links: [
      { label: 'OfferBox', href: '#service' },
      { label: 'dodaキャンパス', href: '#service' },
    ],
  },
];

export default function Footer() {
  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#f7f5f2] border-t border-gray-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 sm:gap-10">
          {/* Brand */}
          <div className="sm:col-span-2">
            <img
              src="https://storage.readdy-site.link/project_files/54722571-b9ba-49ee-a788-8f8a3d9e793f/07172bbf-28a4-4716-a4ee-585cff9bfcba_scout_boost_logo_.png?v=683c30006aab33bfd4298263e9181637"
              alt="ScoutPro"
              className="h-16 md:h-24 w-auto object-contain mb-3"
            />
            <p className="text-sm text-[#777] leading-relaxed max-w-xs">
              新卒採用スカウト送信代行サービス。<br />
              OfferBox・dodaキャンパスに対応し、<br />
              ターゲット設計から送信管理まで一貫して支援します。
            </p>
            <div className="mt-6">
              <a
                href="#contact"
                onClick={(e) => handleNav(e, '#contact')}
                className="inline-flex items-center gap-2 bg-[#1a2e4a] text-white text-sm font-medium px-5 py-2.5 rounded-full hover:bg-[#263f66] transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-send-line text-sm" />
                お問い合わせはこちら
              </a>
            </div>
            <div className="mt-3">
              <a
                href="https://hapicareers.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-sm text-[#777] hover:text-[#1a2e4a] transition-colors duration-150 cursor-pointer"
              >
                <i className="ri-building-line text-sm" />
                運営会社
              </a>
            </div>
          </div>

          {/* Links */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <p className="text-xs font-bold text-[#1a2e4a] uppercase tracking-widest mb-4">
                {group.title}
              </p>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => handleNav(e, link.href)}
                      className="text-sm text-[#777] hover:text-[#1a2e4a] transition-colors duration-150 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 sm:mt-12 pt-6 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#aaa]">
            &copy; 2026 scoutboost. All rights reserved.
          </p>
          <p className="text-xs text-[#aaa] text-center sm:text-right">
            新卒採用スカウト送信代行 | OfferBox・dodaキャンパス対応
          </p>
        </div>
      </div>
    </footer>
  );
}
